import { BaseAction } from './BaseAction';
import Locale from '../../utils/Locale';

export class FreezeProtectOff extends BaseAction {
    public static getTitle:Function = () => Locale.gettext('Freeze Protect Off');
    public static getDescription:Function = () => Locale.gettext('Freeze protect turned off');
    public static supportedRoutes:string[] = [ "push", "email" ];
}